import i18n from '@/i18n/index.js'
import { api } from '@/lib/http.js'
import { later } from '@/lib/undoable.js'
import { useUi } from '@/stores/ui.js'

/** What a note can be on (D-44): the records whose timelines show notes. */
export const NOTE_ON = ['account', 'contact', 'lead', 'opportunity', 'activity', 'offer', 'competitor']

/**
 * A note moved to another record (D-347): sent after the seconds to undo it (D-299), from where
 * the person saw it — Core refuses when someone moved it meanwhile. `done` once it is there.
 */
export function moveNote(note, to, { done = () => {} } = {}) {
  const t = i18n.global.t
  const from = note.noteable?.uuid ? { entity: note.noteable.entity, uuid: note.noteable.uuid } : null
  return later(t('notes.move.moving', { to: to.label }), async () => {
    await api(`/notes/${note.uuid}/move`, { method: 'POST', body: { to: { entity: to.entity, uuid: to.uuid }, from } })
    useUi().success(t('notes.move.moved', { to: to.label }))
    done()
  })
}

/** A note's first line, to name what it becomes (an activity's subject). */
export function firstLine(note, max = 120) {
  const line = String(note?.body_text || '').split('\n').map((l) => l.trim()).find(Boolean) || ''
  return line.length > max ? `${line.slice(0, max - 1)}…` : line
}
